
import { updateAppConfig } from '#app'
import { defuFn } from '/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "875b7362-ce70-4fda-8abe-a8feaf027a00"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
